import React, { useState, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    copyToClipboard,
    generateHiddenColumns,
    cleanObject,
    hasPermission,
    assetsPermissionOptions,
    assetsUseManageOptions,
    createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave, FormDialog } from '../../components/FormDialog/FormDialog';
import AutorenewIcon from '@mui/icons-material/Autorenew';
//import RotateRightOutlinedIcon from '@mui/icons-material/RotateRightOutlined';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import ActionDialog from "../../components/Dialogs/ActionDialog";
import DraggableDialog from "../../components/Dialogs/DraggableDialog";
import axios from 'axios';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import { Typography } from "@mui/material";
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

import Ajv from "ajv";

import EnvisionDocumentPropertiesPanel from './EnvisionDocumentPropertiesPanel';
const envisionDocumentSchemaCreate = require("../../json/envisionDocumentSchema.json").create.required;
const envisionDocumentStatusSchemaView = require("../../json/envisionStatusSchema.json").view;

const uiSchema = {
    "metadata": {
        "ui:options": {
            orderable: false,
            addable: false,
            removable: false
        }
    }
};

const ajv = new Ajv({ strict: false });

const DocumentEnvisionProcessStatusTabPanel = ({ setNotify, createEnvisionDocument, setOpenEnvisionDocument }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    const [envisionDocumentStatusJsonData, setEnvisionDocumentStatusJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [openEnvisionDocumentStatusDialog, setOpenEnvisionDocumentStatusDialog] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [envisionDocumentStatusMode, setEnvisionDocumentStatusMode] = useState('view');  // default to view mode
    const [openInfoDialog, setOpenInfoDialog] = useState(false);
    const [readOnly, setReadOnly] = useState(false);

    const [reload, setReload] = useState(false);
    const [isLoading, setIsloading] = useState(false);

    const [envisionProcessStatus, setEnvisionProcessStatus] = usePersistentStorage("envisionProcessStatus", []);

    //const origination = "CSP";

    useEffect(() => {
        if (createEnvisionDocument) {
            createEnvisionProcessData();
        }
    }, [createEnvisionDocument]);

    useEffect(() => {
        setApiData(envisionProcessStatus);
    }, []);

    const reprocessDialogTitle = "Reprocess Instruction";

    const reprocessInstructions =
        <>
            <Typography variant="body1" paragraph="true">
                <AutorenewIcon style={{ verticalAlign: "middle" }} /> Force Reprocess: Server sends the docs to the ML and updates the ML results to the CSP tenant when available.Partial or Full.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The button below the filter reprocess everything on the page.
                The bulk reprocess action will skip any documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>

            <Typography variant="body1" paragraph="true">
                The reprocess icon in the table reprocess individual document.
                The reprocess icon will be disabled for documents in DOCUMENT_DELETED or WORKFLOW_DELETED state.
            </Typography>
        </>;

    const envisionWorkflowInstructions = "Click the 'Process State' cell link in order to view Envision workflow status";

    // API URL is dynamic in that COMPANY_ID is replaced
    //const apiURL = '/api/companies/%COMPANY_ID%/evDocuments?';
    const apiURL = '/api/companies/%COMPANY_ID%/evDocuments/process/states?';

    const formId = 'EnvisionDocumentDialog';

    const totalLabel = "Matching enVision Documents";
    const saveButtonText = "Save enVision Document";

    // companyId (long), documentGUID, documentType, imageDownloadUrl, blobType, source, processType, metadata (object), mlResultPath, errorMessage, state (DOCUMENT_CREATED, IN_PROCESS, PROCESSED, PROCESS_ERROR) 

    const fieldData = [
        'documentGUID', 'documentType', 'blobType', 'fileName',
        'source', 'processType', 'state', 'mlResultFile', 'mlErrorMessage',
        'createdDate', 'modifiedDate'
    ];

    const hasAssetsUseManage = hasPermission(permissions, assetsUseManageOptions);

    const sortFieldData = [
        // {
        //     field: 'companyId',
        //     label: 'Company ID'
        // },
        {
            field: 'documentGUID',
            label: 'Document GUID'
        },
        {
            field: 'documentType',
            label: 'Document Type'
        },
        {
            field: 'fileName',
            label: 'Filename'
        },
        {
            field: 'state',
            label: 'State'
        },
        {
            field: 'source',
            label: 'Source'
        },
        {
            field: 'processType',
            label: 'Process Type'
        },
        {
            field: 'blobType',
            label: 'Blob Type'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'modifiedDate',
            label: 'Modified Date'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'actions',
            hideable:false,
            type: 'actions',
            headerName: 'Actions',
            minWidth: 120,
            maxWidth: 120,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params),
            renderHeader: (params) => (
                <>
                    {params.colDef.headerName}
                    <IconButton aria-label="reprocess instructions" onClick={showReprocessInstructions}>
                        <InfoIcon />
                    </IconButton>
                </>
            ),
        },
        {
            field: 'companyId',
            headerName: 'Company ID',
            hideable:false,
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'processType',
            hideable:false,
            headerName: 'Process Type',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    // <span style={{ color: params.value.localeCompare("DOCUMENT") === 0 ? '#66E7D4' : '#3371FF' }}>{params.value}</span>
                    <>
                        {params.value.localeCompare("DOCUMENT") === 0 &&
                            <Chip
                                className="type1"
                                avatar={<Avatar>D</Avatar>}
                                label={params.value}
                                variant="outlined"
                                size="small"
                            />
                        }
                        {params.value.localeCompare("WORKFLOW") === 0 &&
                            <Chip
                                className="type2"
                                avatar={<Avatar>W</Avatar>}
                                label={params.value}
                                variant="outlined"
                                size="small"
                            />
                        }
                        {params.value.localeCompare("CLASSIFICATION") === 0 &&
                            <Chip
                                className="type3"
                                avatar={<Avatar>C</Avatar>}
                                label={params.value}
                                variant="outlined"
                                size="small"
                            />
                        }
                    </>
                );
            },
        },
        {
            field: 'documentGUID',
            hideable:false,
            headerName: 'Document GUID',
            minWidth: 325,
            maxWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '275px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document GUID" onClick={(event) => copyToClipboard(event, params.row.documentGUID)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'processStartTime',
            hideable:false,
            headerName: 'Process Start Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedStartTime = "";
                if (params.value > 0) {
                    formattedStartTime = new Date(params.value).toISOString();
                }
                return formattedStartTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },
        {
            field: 'imageDownloadUrl',
            hideable:false,
            headerName: 'Image Download URL',
            minWidth: 475,
            maxWidth: 475,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '430px', overflow: "hidden", textOverflow: "ellipsis" }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy image url" onClick={(event) => copyToClipboard(event, params.row.imageDownloadUrl)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },

        {
            field: 'source',
            headerName: 'Origination ',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            hide: true,
            renderCell: renderCellExpand,
        },
        {
            field: 'fileName',
            hideable:false,
            headerName: 'File Name',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'documentType',
            hideable:false,
            headerName: 'Document Type',
            minWidth: 225,
            maxWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'blobType',
            hideable:false,
            headerName: 'Mime Type',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'state',
            hideable:false,
            headerName: 'Process State',
            minWidth: 250,
            maxWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            cellClassName: 'state-header',
            renderHeader: (params) => {
                return (
                    <>
                        <span style={{ fontWeight: 500 }}>{params.colDef.headerName}</span>
                        <Tooltip title={envisionWorkflowInstructions} arrow placement="top">
                            <InfoIcon style={{ verticalAlign: 'middle', marginLeft: '5px' }} />
                        </Tooltip>
                    </>
                );
            },
            renderCell: (params) => {
                return (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            // get json data
                            fetchEnvisionDocumentStatus(params.row.companyId, params.row.documentGUID);
                        }}
                    >
                        <span style={{ color: params.value.includes("ERROR") ? '#FF0000' : '#000000' }}>{params.value}</span>

                    </Link>
                );
            },
        },

        {
            field: 'metadata',
            headerName: 'Metadata',
            minWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            hide: true,

            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                        {params.value && Object.keys(params.value).map((name) => (
                            <><strong><u>{name}</u></strong>:<br />
                                <>&nbsp;{JSON.stringify(params.value[name], null, 2)}<br /></>
                            </>
                        ))}
                    </div>
                );
            },
        },
        {
            field: 'mlResultFile',
            hideable:false,
            headerName: 'ML Result',
            minWidth: 350,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="clipboardContent">
                        <div style={{ width: '275px', wordBreak: 'break-word' }}>
                            {params.value}
                        </div>

                        {params.value && (
                            <Tooltip title="Copy to clipboard" arrow placement="right">
                                <IconButton aria-label="copy ML Result File Path" onClick={(event) => copyToClipboard(event, params.row.mlResultFile)}>
                                    <CopyIcon sx={{ fontSize: 'small' }} />
                                </IconButton>
                            </Tooltip>


                        )}
                    </div>
                );
            }
        },
        {
            field: 'mlErrorMessage',
            hideable:false,
            headerName: 'Error',
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                return (
                    <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left', wordBreak: 'break-word' }}>
                        {params.value}
                    </div>
                );
            }
        },
        {
            field: 'createdDate',
            headerName: 'Created Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'modifiedDate',
            headerName: 'Modified Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },

    ];

    const getColumns = () => {
        return (hasAssetsUseManage && columns) || columns.filter(obj => { return obj.field !== "actions"});
    };

    const toggleColumnPinning = () => {
        return (hasAssetsUseManage && 'columnPinning') || '';
    };

    const getActionButtons = (params) => {
        let actionButtons = [];

        let reprocessButton = <GridActionsCellItem icon={
            <Tooltip title="reprocess: Server sends this document to the ML and updates the ML results when available." arrow placement="right">
                <AutorenewIcon />
            </Tooltip>}
            label='Reprocess Envision Document'
            onClick={() => {
                reprocessData(params.row.companyId, params.row.documentGUID);
            }}
            disabled={params.row.state === 'DOCUMENT_DELETED' || params.row.state === 'WORKFLOW_DELETED'}
        />;

        hasAssetsUseManage && actionButtons.push(reprocessButton);

        return actionButtons;

    };

    const reprocessData = (companyId, documentGUID) => {
        // console.log("reprocess button clicked", companyId, documentGUID);

        let reprocessUrl = `/api/companies/${companyId}/evDocuments/${documentGUID}/reprocess`;

        axios({
            method: "put", url: reprocessUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                // console.log("Total " + response.data.length + " document(s) were initiated for reprocess");

                let message = `Reprocess initiated for enVision document [${companyId}, ${documentGUID}]

                Please wait a few minutes and reload the table to view reprocess state`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // reload table data after reprocess
                setReload(true);
            }).catch(error => {
                console.log('error in reprocess documents api call:', error);

                let message = `Failed to initiate reprocess for enVision document [${companyId}, ${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

            });
    };

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating table data: ", data);
                setApiData(data);
                setEnvisionProcessStatus(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load enVision document process status data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });

    };

    const transformMetadataToArrayFormat = (data) => {

        if (data) {
            let metadata = data.metadata;

            if (metadata) {
                const objMap = new Map(Object.entries(metadata));
                const arrayData = [...objMap].map(([name, value]) => {
                    value = JSON.stringify(value);
                    return { name, value };
                });

                data.metadata = arrayData;
            }
        }
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        // transform metadata object format to string format for view dialog
        transformMetadataToArrayFormat(formattedData);

        setRowJsonData(formattedData);
        setMode('view');
        setOpen(true);
        setReadOnly(true);
    };


    const fetchEnvisionDocumentStatus = (companyId, documentGUID) => {

        let envisionDocumentStatusUrl = `/api/companies/${companyId}/evDocuments/${documentGUID}/process/state`;

        axios({
            method: "GET", url: envisionDocumentStatusUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                const JsonData = response.data;

                if (JsonData) {
                    setEnvisionDocumentStatusJsonData(JsonData);
                    setEnvisionDocumentStatusMode('view');
                    setOpenEnvisionDocumentStatusDialog(true);
                } else {
                    let message = `No enVision status data exists for enVision document ${documentGUID}`;

                    setNotify({
                        isOpen: true,
                        message: message,
                        severity: 'info'
                    });
                }

            }).catch(error => {
                console.log('error in fetch enVision document status api call:', error);

                let message = `Failed to fetch enVision document status [${companyId}, ${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

            });
    };

    const validateSchema = (envisionDocumentSchema, data) => {
        // console.log('got json schema', envisionDocumentSchema);
        const validate = ajv.compile(envisionDocumentSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }

    const saveEnvisionDocumentData = (formData) => {

        // console.log('called save enVision document:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        /*
        if (mode === 'edit') {
            if (validateSchema(scheduleSchemaUpdate, cleanedObj)) {
                //call save API
                console.log('validated successfully..');
                updateConnectorSchedule(cleanedObj);
            } else {
                console.log('update schema validation failed..');
                let message = `Update connector schedule schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }
        }
        */

        if (mode === 'create') {
            if (validateSchema(envisionDocumentSchemaCreate, cleanedObj)) {
                // console.log('create enVision schema validated successfully..');
                createEnvisionDocumentData(cleanedObj);
            }
            else {
                console.log('create enVision schema validation failed..');
                let message = `Create enVision schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setOpenEnvisionDocument(false);
        }
    };


    const transformMetaData = (data) => {
        let metadata = data.metadata;   // get array of data

        let metadataObj = {};

        if (metadata) {
            metadata.forEach((obj) => {
                const valObj = JSON.parse(obj.value);
                metadataObj[obj.name] = valObj;
            });
        }

        data.metadata = metadataObj;

    };


    const createEnvisionDocumentData = (data) => {
        try {
            // console.log('inside enVision create api..');

            transformMetaData(data);

            //let createUrl = `/api/companies/${data.companyId}/connectors/schedules`;
            let createUrl = `/api/companies/${data.companyId}/evDocuments/process`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        // console.log('got response from enVision document create:', response);

                        let message = `Created enVision document [${response.data.documentGUID}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // refresh the table
                        setReload(true);
                        setOpen(false);
                    }
                }).catch(error => {
                    let message = `Failed to create enVision document \n\n ${error.response.statusText} : ${error.response.data.message}`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });

                    console.log('error in create enVision document api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to create enVision document `;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };

    const createEnvisionProcessData = () => {
        let rowData = {};
        const JsonData = rowData;

        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const showReprocessInstructions = () => {
        // console.log("enVision reprocess info button clicked");

        setOpenInfoDialog(true);
    };

    const handleClose = () => {
        setOpen(false);

        setOpenEnvisionDocument(false);
    };

    const handleInfoDialogClose = () => {
        setOpenInfoDialog(false);
    };


    const handleEnvisionDocumentStatusClose = () => {
        setOpenEnvisionDocumentStatusDialog(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    };

    const handleJsonChange = (formData) => {
        // console.log("Dialog JSON has changed", formData);

        setRowJsonData(formData);

    };

    const hasAssetsUsePermission = hasPermission(permissions, assetsUseManageOptions);
    return (
        <>
            <div id="envisionProcessStatusDocumentfilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={assetsPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={true} totalLabel={totalLabel} includeEnvisionDocActions={hasAssetsUsePermission} tabName={'documentEnvisionProcessStatusTab'} />
            </div>


            <Divider />

            <div id="envisionProcessDocumentStatusTableContainer" className={toggleColumnPinning()}>
                <div>
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>


            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveEnvisionDocumentData)}
                title="enVision Document Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <EnvisionDocumentPropertiesPanel formId={formId}
                        envisionDocumentSchema={envisionDocumentSchemaCreate}
                        saveEnvisionDocumentData={saveEnvisionDocumentData}
                        formData={rowJsonData} handleFormChange={handleFormChange}
                        readOnly={readOnly} />
                }
                jsonDataName="enVision documents"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />

            {/* This dialog only support view. No need for form or save */}
            <ActionDialog
                open={openEnvisionDocumentStatusDialog}
                mode={envisionDocumentStatusMode}
                onClose={handleEnvisionDocumentStatusClose}
                title="enVision Document Status Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'envisionDocumentStatusDialogId'}
                        readOnly={true}
                        schema={envisionDocumentStatusSchemaView}
                        uiSchema={uiSchema}
                        formData={envisionDocumentStatusJsonData}
                    />
                }
                jsonDataName="enVision document status"
                JSONTabContent={envisionDocumentStatusJsonData}
            />

            <DraggableDialog
                open={openInfoDialog}
                onClose={handleInfoDialogClose}
                title={reprocessDialogTitle}
                content={reprocessInstructions}
            />

        </>
    );
}

export default DocumentEnvisionProcessStatusTabPanel;